import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { SINGLE_OFFICE_MODE } from '../../config';
import BtnBack from '../../common/BtnBack/BtnBack';
import InfoPanel from '../../common/InfoPanel/InfoPanel';
import LabelMainColor from '../../common/LabelMainColor/LabelMainColor';
import RowHorizontal from '../../common/RowHorizontal/RowHorizontal';
import TitleTop from '../../common/TitleTop/TitleTop';
import TextWrapper from '../../common/TextWrapper/TextWrapper';
import DataWrapper from '../../common/DataWrapper/DataWrapper';
import TableTimes from './TableTimes';
import Calendar, { COMMON_DATE_FORMAT } from './Calendar';

import { StyledIntervalsContent } from './styles/StyledIntervalsContent';


class IntervalsContent extends Component {
  render() {
    const { 
      daysData, intervalsData, officeData, serviceData, deleteReservationData, intervalsCommon, previousSteps, btnBackTitle,
      officeId,
      handleOnClickDay,
      selectedDateDay, 
      onClickTableRow,
      handleMonthChange,
    } = this.props;

    const showTable = daysData.status && selectedDateDay !== null

    return (
      <StyledIntervalsContent>

        <BtnBack 
          text={`ZPĚT NA ${btnBackTitle}`}
          linkTo={ SINGLE_OFFICE_MODE ? '/' : '/office/' + officeId}
        />
        <InfoPanel
          locationData={{
            show: true,
            title: previousSteps.one,
            text1: officeData.data.pub_server_name,
            text2: officeData.data.server_address,
            place: officeData.data.place,
            placeAdditionalInfo: officeData.data.place_additional_info,
            isLoading: officeData.isLoading || deleteReservationData.isLoading,
            status: officeData.status,
          }}
          serviceData={{
            show: true,
            title: previousSteps.two,
            text1: serviceData.data.name,
            isLoading: serviceData.isLoading,
            status: serviceData.status,
          }}
          timeData={{
            show: false,
          }}
        />

        <RowHorizontal />

        <TitleTop   
          number={SINGLE_OFFICE_MODE ? 2 : 3}
          title={intervalsCommon.title}
        />

        <TextWrapper>
          {<div dangerouslySetInnerHTML={{ __html: intervalsCommon.content }}></div>}
        </TextWrapper>

        <LabelMainColor
          type="h2"
          title="Kalendář"
        />

        <DataWrapper
          isLoading={daysData.isLoading}
          status={daysData.status}
          minHeight={350}
          isLoadingText="Načítám"
          errorMessage="Nepodařilo se načíst data. Zkuste prosím stránku načíst znovu, nebo opakujte akci později."
        >          
          <Calendar
            days={daysData.data}
            dateToDayMap={getDateToDayMap(daysData.data)}
            handleOnClickDay={handleOnClickDay}
            selectedDate={selectedDateDay}
            handleMonthChange={handleMonthChange}
          />
        </DataWrapper>

        <div id="intervals">
          <LabelMainColor
            type="h3"
            title="Termíny"
          />
        </div>

        { showTable
           && (
            <DataWrapper
              isLoading={intervalsData.isLoading}
              status={intervalsData.status}
              isLoadingText="Načítám"
              errorMessage="Nepodařilo se načíst data. Zkuste prosím stránku načíst znovu, nebo opakujte akci později."
              minHeight={80}
            >
              <TableTimes
                header1="Čas"
                header2="Volná místa / Celkem"
                data={intervalsData.data}
                onClickRow={onClickTableRow}
              />
            </DataWrapper>
          )
        }
        
      </StyledIntervalsContent>      
    );
  }
}


IntervalsContent.propTypes = {
  previousSteps: PropTypes.object.isRequired,
  intervalsCommon: PropTypes.object.isRequired,
  daysData: PropTypes.object.isRequired,
  intervalsData: PropTypes.object.isRequired,
  officeData: PropTypes.object.isRequired,
  serviceData: PropTypes.object.isRequired,
  deleteReservationData: PropTypes.object.isRequired,
  officeId: PropTypes.string.isRequired,
  handleOnClickDay: PropTypes.func.isRequired,
  selectedDateDay: PropTypes.any,
  onClickTableRow: PropTypes.func.isRequired,
  handleMonthChange: PropTypes.func.isRequired,
};


const getDateToDayMap = (days) => {
  return days.reduce((result, day) => {
    const date = moment(day.date).format(COMMON_DATE_FORMAT)
    result[date] = day
    return result
  }, {})
}

export default IntervalsContent;
